const formats =[
  {
    "client": "Geral",
    "folders": [
      {
        "id": 1,
        "name": "HTML",
        "parent": null,
        "show": true,
        "openned": false
      },
      {
        "id": 2,
        "name": "Horizontal",
        "parent": "HTML",
        "show": false,
        "openned": false,
      },
      {
        "id": 3,
        "name": "Vertical",
        "parent": "HTML",
        "show": false,
        "openned": false,
      },
      {
        "id": 4,
        "name": "Mobile",
        "parent": "HTML",
        "show": false,
        "openned": false,
      },
      {
        "id": 5,
        "name": "Quadrado",
        "parent": "HTML",
        "show": false,
        "openned": false,
      },
      {
        "id": 6,
        "name": "VIDEO",
        "parent": null,
        "show": true,
        "openned": false
      },
      {
        "id": 7,
        "name": "RETAIL",
        "parent": null,
        "show": true,
        "openned": false
      }
    ],
    "formats": [
      { "id": 1, "type": "Format", "width": 234, "height": 60, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 2,  "type": "Format", "width": 468, "height": 60, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 3,  "type": "Format", "width": 728, "height": 90, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 4,  "type": "Format", "width": 970, "height": 90, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 5,  "type": "Format", "width": 970, "height": 150, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 6,  "type": "Format", "width": 970, "height": 250, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 7,  "type": "Format", "width": 120, "height": 600, "show": false, "ativo": false, "parent": "Vertical" },
      { "id": 8,  "type": "Format", "width": 160, "height": 600, "show": false, "ativo": false, "parent": "Vertical" },
      { "id": 9,  "type": "Format", "width": 240, "height": 400, "show": false, "ativo": false, "parent": "Vertical" },
      { "id": 10,  "type": "Format", "width": 300, "height": 600, "show": false, "ativo": false, "parent": "Vertical" },
      { "id": 11,  "type": "Format", "width": 300, "height": 50, "show": false, "ativo": false, "parent": "Mobile" },
      { "id": 12,  "type": "Format", "width": 320, "height": 50, "show": false, "ativo": false, "parent": "Mobile" },
      { "id": 13,  "type": "Format", "width": 320, "height": 100, "show": false, "ativo": false, "parent": "Mobile" },
      { "id": 14,  "type": "Format", "width": 125, "height": 125, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 15,  "type": "Format", "width": 200, "height": 200, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 16,  "type": "Format", "width": 240, "height": 240, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 17,  "type": "Format", "width": 250, "height": 250, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 18,  "type": "Format", "width": 300, "height": 250, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 19,  "type": "Format", "width": 336, "height": 280, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 20,  "type": "Format", "width": 600, "height": 600, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 21,  "type": "Format", "width": 1080, "height": 1080, "show": false, "ativo": false, "parent": "VIDEO" },
      { "id": 22,  "type": "Format", "width": 1080, "height": 1920, "show": false, "ativo": false, "parent": "VIDEO" },
      { "id": 23,  "type": "Format", "width": 1280, "height": 720, "show": false, "ativo": false, "parent": "VIDEO" },
      { "id": 24,  "type": "Format", "width": 1920, "height": 1080, "show": false, "ativo": false, "parent": "VIDEO" },
      { "id": 25,  "type": "Format", "width": 350, "height": 350, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 26,  "type": "Format", "width": 400, "height": 400, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 27,  "type": "Format", "width": 500, "height": 500, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 28,  "type": "Format", "width": 600, "height": 600, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 29,  "type": "Format", "width": 750, "height": 750, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 30,  "type": "Format", "width": 800, "height": 800, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 31,  "type": "Format", "width": 900, "height": 900, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 32,  "type": "Format", "width": 1000, "height": 1000, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 33,  "type": "Format", "width": 1104, "height": 1600, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 34,  "type": "Format", "width": 1200, "height": 900, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 35,  "type": "Format", "width": 1200, "height": 1200, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 36,  "type": "Format", "width": 1500, "height": 1500, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 37,  "type": "Format", "width": 1800, "height": 1800, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 38,  "type": "Format", "width": 2000, "height": 2000, "show": false, "ativo": false, "parent": "RETAIL" },
      { "id": 39,  "type": "Format", "width": 3000, "height": 3000, "show": false, "ativo": false, "parent": "RETAIL" }
    ]
  },
  {
    "client": "Livelo",
    "folders": [
      {
        "id": 1,
        "name": "Enxoval Promo",
        "parent": null,
        "show": true,
        "openned": false
      },
      {
        "id": 2,
        "name": "AON de Mídia",
        "parent": null,
        "show": true,
        "openned": false
      },
      {
        "id": 3,
        "name": "Canal do WhatsApp",
        "parent": null,
        "show": true,
        "openned": false
      },
      {
        "id": 4,
        "name": "Site e App",
        "parent": null,
        "show": true,
        "openned": false
      }
    ],
    "formats": [
        { "id": 1, "type": "Format", "width": 1080, "height": 1080, "show": false, "ativo": false, "parent": "Enxoval Promo" },
        { "id": 2,  "type": "Format", "width": 1080, "height": 1920, "show": false, "ativo": false, "parent": "Enxoval Promo" },
        { "id": 3,  "type": "Format", "width": 1200, "height": 628, "show": false, "ativo": false, "parent": "Enxoval Promo" },
        { "id": 4,  "type": "Format", "width": 1920, "height": 1080, "show": false, "ativo": false, "parent": "Enxoval Promo" },
        { "id": 5,  "type": "Format", "width": 960, "height": 1200, "show": false, "ativo": false, "parent": "Enxoval Promo" },
        { "id": 6,  "type": "Format", "width": 970, "height": 250, "show": false, "ativo": false, "parent": "Enxoval Promo" },
        { "id": 7,  "type": "Format", "width": 728, "height": 90, "show": false, "ativo": false, "parent": "Enxoval Promo" },
        { "id": 8,  "type": "Format", "width": 960, "height": 1200, "show": false, "ativo": false, "parent": "Enxoval Promo" },
        { "id": 9,  "type": "Format", "width": 1080, "height": 1080, "show": false, "ativo": false, "parent": "AON de Mídia" },
        { "id": 10,  "type": "Format", "width": 1080, "height": 1920, "show": false, "ativo": false, "parent": "AON de Mídia" },
        { "id": 11,  "type": "Format", "width": 1200, "height": 628, "show": false, "ativo": false, "parent": "AON de Mídia" },
        { "id": 12,  "type": "Format", "width": 970, "height": 250, "show": false, "ativo": false, "parent": "AON de Mídia" },
        { "id": 13,  "type": "Format", "width": 1920, "height": 1080, "show": false, "ativo": false, "parent": "AON de Mídia" },
        { "id": 14,  "type": "Format", "width": 728, "height": 90, "show": false, "ativo": false, "parent": "AON de Mídia" },
        { "id": 15,  "type": "Format", "width": 960, "height": 1200, "show": false, "ativo": false, "parent": "AON de Mídia" },
        { "id": 16,  "type": "Format", "width": 600, "height": 900, "show": false, "ativo": false, "parent":"Canal do WhatsApp" },
        { "id": 17,  "type": "Format", "width": 600, "height": 350, "show": false, "ativo": false, "parent":"Canal do WhatsApp" },
        { "id": 18,  "type": "Format", "width": 600, "height": 150, "show": false, "ativo": false, "parent":"Canal do WhatsApp" },
        { "id": 19,  "type": "Format", "width": 600, "height": 230, "show": false, "ativo": false, "parent":"Canal do WhatsApp" },
        { "id": 20,  "type": "Format", "width": 265, "height": 200, "show": false, "ativo": false, "parent":"Canal do WhatsApp" },
        { "id": 21,  "type": "Format", "width": 265, "height": 400, "show": false, "ativo": false, "parent":"Canal do WhatsApp" },
        { "id": 22,  "type": "Format", "width": 1392, "height": 557, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 23,  "type": "Format", "width": 771, "height": 578, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 24,  "type": "Format", "width": 360, "height": 160, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 25,  "type": "Format", "width": 664, "height": 290, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 26,  "type": "Format", "width": 1400, "height": 175, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 27,  "type": "Format", "width": 1024, "height": 256, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 28,  "type": "Format", "width": 448, "height": 221, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 29,  "type": "Format", "width": 70, "height": 20, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 30,  "type": "Format", "width": 630, "height": 230, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 31,  "type": "Format", "width": 2784, "height": 348, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 32,  "type": "Format", "width": 365, "height": 174, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 33,  "type": "Format", "width": 2784, "height": 348, "show": false, "ativo": false, "parent": "Site e App" },
        { "id": 34,  "type": "Format", "width": 1027, "height": 174, "show": false, "ativo": false, "parent": "Site e App" }
    ]
  },
  {
    "client": "Omnicom",
    "folders": [
      {
        "id": 1,
        "name": "HTML",
        "parent": null,
        "show": true,
        "openned": false
      },
      {
        "id": 2,
        "name": "Horizontal",
        "parent": "HTML",
        "show": false,
        "openned": false,
      },
      {
        "id": 3,
        "name": "Vertical",
        "parent": "HTML",
        "show": false,
        "openned": false,
      },
      {
        "id": 4,
        "name": "Mobile",
        "parent": "HTML",
        "show": false,
        "openned": false,
      },
      {
        "id": 5,
        "name": "Quadrado",
        "parent": "HTML",
        "show": false,
        "openned": false,
      },
      {
        "id": 6,
        "name": "VIDEO",
        "parent": null,
        "show": true,
        "openned": false
      },
      {
        "id": 7,
        "name": "RETAIL",
        "parent": null,
        "show": true,
        "openned": false
      },
      {
        "id": 8,
        "name": "Amazon",
        "parent": "RETAIL",
        "show": false,
        "openned": false
      },
      {
        "id": 9,
        "name": "Mercado Livre",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 10,
        "name": "IFOOD",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 11,
        "name": "D2C",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 12,
        "name": "MATEUS",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 13,
        "name": "PAULISTÃO",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 14,
        "name": "PREZUNIC",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 15,
        "name": "MAMBO",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 16,
        "name": "NORDESTÃO",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 17,
        "name": "BISTEK",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 18,
        "name": "IMPERATRIZ",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 19,
        "name": "GIASSI",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      },
      {
        "id": 20,
        "name": "BARBOSA",
        "parent": "RETAIL",
        "show": false,
        "openned": false,
      }
    ],
    "formats": [
      { "id": 1, "type": "Format", "width": 234, "height": 60, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 2,  "type": "Format", "width": 468, "height": 60, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 3,  "type": "Format", "width": 728, "height": 90, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 4,  "type": "Format", "width": 970, "height": 90, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 5,  "type": "Format", "width": 970, "height": 150, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 6,  "type": "Format", "width": 970, "height": 250, "show": false, "ativo": false, "parent": "Horizontal" },
      { "id": 7,  "type": "Format", "width": 120, "height": 600, "show": false, "ativo": false, "parent": "Vertical" },
      { "id": 8,  "type": "Format", "width": 160, "height": 600, "show": false, "ativo": false, "parent": "Vertical" },
      { "id": 9,  "type": "Format", "width": 240, "height": 400, "show": false, "ativo": false, "parent": "Vertical" },
      { "id": 10,  "type": "Format", "width": 300, "height": 600, "show": false, "ativo": false, "parent": "Vertical" },
      { "id": 11,  "type": "Format", "width": 300, "height": 50, "show": false, "ativo": false, "parent": "Mobile" },
      { "id": 12,  "type": "Format", "width": 320, "height": 50, "show": false, "ativo": false, "parent": "Mobile" },
      { "id": 13,  "type": "Format", "width": 320, "height": 100, "show": false, "ativo": false, "parent": "Mobile" },
      { "id": 14,  "type": "Format", "width": 125, "height": 125, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 15,  "type": "Format", "width": 200, "height": 200, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 16,  "type": "Format", "width": 240, "height": 240, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 17,  "type": "Format", "width": 250, "height": 250, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 18,  "type": "Format", "width": 300, "height": 250, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 19,  "type": "Format", "width": 336, "height": 280, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 20,  "type": "Format", "width": 600, "height": 600, "show": false, "ativo": false, "parent": "Quadrado" },
      { "id": 21,  "type": "Format", "width": 1080, "height": 1080, "show": false, "ativo": false, "parent": "VIDEO" },
      { "id": 22,  "type": "Format", "width": 1080, "height": 1920, "show": false, "ativo": false, "parent": "VIDEO" },
      { "id": 23,  "type": "Format", "width": 1280, "height": 720, "show": false, "ativo": false, "parent": "VIDEO" },
      { "id": 24,  "type": "Format", "width": 1920, "height": 1080, "show": false, "ativo": false, "parent": "VIDEO" },
      {  "id": 25,  "type": "Format", "width": 1940, "height": 500, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 26,  "type": "Format", "width": 160, "height": 600, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 27,  "type": "Format", "width": 980, "height": 55, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 28,  "type": "Format", "width": 600, "height": 500, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 29,  "type": "Format", "width": 1242, "height": 375, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 30,  "type": "Format", "width": 728, "height": 90, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 31,  "type": "Format", "width": 640, "height": 100, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 32,  "type": "Format", "width": 300, "height": 600, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 33,  "type": "Format", "width": 1200, "height": 628, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 34,  "type": "Format", "width": 300, "height": 50, "show": false, "ativo": false, "parent": "Amazon" },
      {  "id": 35,  "type": "Format", "width": 320, "height": 100, "show": false, "ativo": false, "parent": "Amazon" },              
      {  "id": 36,  "type": "Format", "width": 528, "height": 528, "show": false, "ativo": false, "parent": "Mercado Livre" },
      {  "id": 37,  "type": "Format", "width": 1008, "height": 528, "show": false, "ativo": false, "parent": "Mercado Livre" },
      {  "id": 38,  "type": "Format", "width": 328, "height": 323, "show": false, "ativo": false, "parent": "Mercado Livre" },
      {  "id": 39,  "type": "Format", "width": 600, "height": 340, "show": false, "ativo": false, "parent": "Mercado Livre" },
      {  "id": 40,  "type": "Format", "width": 1500, "height": 375, "show": false, "ativo": false, "parent": "Mercado Livre" },
      {  "id": 41,  "type": "Format", "width": 720, "height": 160, "show": false, "ativo": false, "parent": "Mercado Livre" },
      {  "id": 42,  "type": "Format", "width": 1920, "height": 300, "show": false, "ativo": false, "parent": "Mercado Livre" },
      {  "id": 43,  "type": "Format", "width": 300, "height": 444, "show": false, "ativo": false, "parent": "IFOOD" },
      {  "id": 44,  "type": "Format", "width": 375, "height": 444, "show": false, "ativo": false, "parent": "IFOOD" },
      {  "id": 45,  "type": "Format", "width": 300, "height": 390, "show": false, "ativo": false, "parent": "IFOOD" },
      {  "id": 46,  "type": "Format", "width": 900, "height": 420, "show": false, "ativo": false, "parent": "IFOOD" },
      {  "id": 47,  "type": "Format", "width": 375, "height": 420, "show": false, "ativo": false, "parent": "D2C" },
      {  "id": 48,  "type": "Format", "width": 1920, "height": 430, "show": false, "ativo": false, "parent": "D2C" },
      {  "id": 49,  "type": "Format", "width": 1300, "height": 350, "show": false, "ativo": false, "parent": "MATEUS" },
      {  "id": 50,  "type": "Format", "width": 1080, "height": 1080, "show": false, "ativo": false, "parent": "MATEUS" },
      {  "id": 51,  "type": "Format", "width": 900, "height": 450, "show": false,"ativo": false, "parent": "MATEUS" },              
      {  "id": 52,  "type": "Format", "width": 390, "height": 200, "show": false, "ativo": false, "parent": "PAULISTÃO" },
      {  "id": 53,  "type": "Format", "width": 1080, "height": 465, "show": false, "ativo": false, "parent": "PAULISTÃO" },
      {  "id": 54,  "type": "Format", "width": 1440, "height": 330, "show": false,"ativo": false, "parent": "PAULISTÃO" },
      {  "id": 55,  "type": "Format", "width": 640, "height": 480, "show": false, "ativo": false, "parent": "PREZUNIC" },
      {  "id": 56,  "type": "Format", "width": 1080, "height": 1920, "show": false, "ativo": false, "parent": "PREZUNIC" },
      {  "id": 57,  "type": "Format", "width": 1320, "height": 320, "show": false, "ativo": false, "parent": "PREZUNIC" },
      {  "id": 58,  "type": "Format", "width": 1366, "height": 320, "show": false,"ativo": false, "parent": "PREZUNIC" },
      {  "id": 59,  "type": "Format", "width": 500, "height": 180, "show": false, "ativo": false, "parent": "MAMBO" },
      {  "id": 60,  "type": "Format", "width": 710, "height": 370, "show": false, "ativo": false, "parent": "MAMBO" },
      {  "id": 61,  "type": "Format", "width": 1000, "height": 370, "show": false, "ativo": false, "parent": "MAMBO" },
      {  "id": 62,  "type": "Format", "width": 1080, "height": 465, "show": false, "ativo": false, "parent": "MAMBO" },
      {  "id": 63,  "type": "Format", "width": 1080, "height": 1920, "show": false,"ativo": false, "parent": "MAMBO" },
      {  "id": 64,  "type": "Format", "width": 2300, "height": 450, "show": false, "ativo": false, "parent": "NORDESTÃO" },
      {  "id": 65,  "type": "Format", "width": 720, "height": 525, "show": false, "ativo": false, "parent": "NORDESTÃO" },
      {  "id": 66,  "type": "Format", "width": 1000, "height": 400, "show": false, "ativo": false, "parent": "NORDESTÃO" },
      {  "id": 67,  "type": "Format", "width": 1080, "height": 1440, "show": false, "ativo": false, "parent": "NORDESTÃO" },
      {  "id": 68,  "type": "Format", "width": 1080, "height": 1920, "show": false,"ativo": false, "parent": "NORDESTÃO" },
      {  "id": 69,  "type": "Format", "width": 700, "height": 1000, "show": false, "ativo": false, "parent": "BISTEK" },
      {  "id": 70,  "type": "Format", "width": 1080, "height": 1080, "show": false, "ativo": false, "parent": "BISTEK" },
      {  "id": 71,  "type": "Format", "width": 1080, "height": 1550, "show": false, "ativo": false, "parent": "BISTEK" },
      {  "id": 72,  "type": "Format", "width": 1600, "height": 700, "show": false, "ativo": false, "parent": "BISTEK" },
      {  "id": 73,  "type": "Format", "width": 1080, "height": 1920, "show": false, "ativo": false, "parent": "BISTEK" },
      {  "id": 74,  "type": "Format", "width": 414, "height": 250, "show": false, "ativo": false, "parent": "IMPERATRIZ" },
      {  "id": 75,  "type": "Format", "width": 1177, "height": 400, "show": false, "ativo": false, "parent": "IMPERATRIZ" },
      {  "id": 76,  "type": "Format", "width": 1920, "height": 350, "show": false, "ativo": false, "parent": "IMPERATRIZ" },
      {  "id": 77,  "type": "Format", "width": 414, "height": 210, "show": false, "ativo": false, "parent": "GIASSI" },
      {  "id": 78,  "type": "Format", "width": 414, "height": 450, "show": false, "ativo": false, "parent": "GIASSI" },
      {  "id": 79,  "type": "Format", "width": 1080, "height": 1080, "show": false, "ativo": false, "parent": "GIASSI" },
      {  "id": 80,  "type": "Format", "width": 1080, "height": 1350, "show": false, "ativo": false, "parent": "GIASSI" },
      {  "id": 81,  "type": "Format", "width": 1252, "height": 210, "show": false, "ativo": false, "parent": "GIASSI" },
      {  "id": 82,  "type": "Format", "width": 1920, "height": 450, "show": false, "ativo": false, "parent": "GIASSI" },
      {  "id": 83,  "type": "Format", "width": 1080, "height": 1920, "show": false,"ativo": false, "parent": "GIASSI" },
      {  "id": 84,  "type": "Format", "width": 350, "height": 480, "show": false, "ativo": false, "parent": "BARBOSA" },
      {  "id": 85,  "type": "Format", "width": 500, "height": 500, "show": false, "ativo": false, "parent": "BARBOSA" },
      {  "id": 86,  "type": "Format", "width": 656, "height": 280, "show": false, "ativo": false, "parent": "BARBOSA" },
      {  "id": 87,  "type": "Format", "width": 1080, "height": 1920, "show": false, "ativo": false, "parent": "BARBOSA" },
      {  "id": 88,  "type": "Format", "width": 1600, "height": 400, "show": false, "ativo": false, "parent": "BARBOSA" },
    ]
  }
]

export default function FormatosReanimate(client = "Geral") {
  if (!client) client = "Geral";
  console.log('client')
  console.log(client)
  let f = formats.find(f => f.client === client);
  if (!f) {
    f = formats.find(f => f.client === "Geral");
  }
  return f;
}